import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestScannerResultExternalsGet = {
    path: "/scanner/result/externals",
    method: RouteHttpVerb.GET
};
export { locationRestScannerResultExternalsGet };
